'use client'

import { IconInfoL } from 'icons/components/IconInfoL'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import type { TooltipChildrenProps } from '@fukku/tooltip'
import { cx } from 'utils/cx'
import styles from './ExtraInfoButton.module.scss'

export type ExtraInfoButtonProps = {
	readonly handleOnClick?: () => void
	readonly horizontal: boolean
	readonly tooltipProps?: TooltipChildrenProps
}

export const ExtraInfoButton = ({
	handleOnClick,
	horizontal,
	...tooltipProps
}: ExtraInfoButtonProps) => {
	const { t } = useLabels()

	return (
		<button
			type='button'
			onClick={handleOnClick}
			className={cx(styles.button, !horizontal && styles.iconVertical)}
			{...tooltipProps}
		>
			<IconInfoL
				className={styles.icon}
				alt={t('accessibility.moreInfo.icon')}
				height={12}
				width={12}
			/>
		</button>
	)
}
